
// Setup mock global variables that are usually injected by the backend
if (typeof window !== 'undefined') {
    (window as any).csrf_token = 'mock-csrf-token';
    (window as any).frappe = {
        boot: {
            sysdefaults: {
                float_precision: 2,
                date_format: 'yyyy-mm-dd'
            },
            user: {
                name: 'Guest User',
                email: 'guest@example.com'
            }
        }
    };
}
